import { Tooltip, TooltipProps } from "@mui/material";
import React from "react";

const WhiteTooltip = ({ placement = "top", ...props }: TooltipProps) => {
  return (
    <Tooltip
      arrow
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#fff", // white background
            color: "#000",           // black text
            boxShadow: 1,
            fontSize: "0.775rem",
            userSelect: "text",
            cursor: "text",
          },
        },
        arrow: {
          sx: {
            color: "#fff",
          },
        },
      }}
      {...props} 
    />
  );
};

export default WhiteTooltip;
